/**
 * OpenTelemetry adapter implementing `ObservabilityProvider`.
 */

import { initOTel, setOTelUser, clearOTelUser, captureException, captureMessage, addBreadcrumb, trace } from "./otel";
import type { ObservabilityProvider, ObservabilityUser } from "./observability";

export class OTelProvider implements ObservabilityProvider {
  init(): void {
    initOTel();
  }

  setUser(user: ObservabilityUser): void {
    setOTelUser(user);
  }

  clearUser(): void {
    clearOTelUser();
  }

  captureException(error: Error, context?: Record<string, unknown>): void {
    captureException(error, context);
  }

  captureMessage(message: string, level: "info" | "warning" | "error" = "info"): void {
    captureMessage(message, level);
  }

  addBreadcrumb(message: string, category?: string, data?: Record<string, unknown>): void {
    addBreadcrumb(message, category, data);
  }
}

export { trace };
